import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()
export class UrlInterceptorService implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldBypass = req.params.get('bypassInterceptor');
    if (shouldBypass) return next.handle(req);

    const url: string = `${!req.url.includes(environment.authServer) ? environment.apiUrl : ''}${req.url}`;

    const apiReq = req.clone({ url });
    return next.handle(apiReq);
  }
}

export const urlInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const shouldBypass = req.params.get('bypassInterceptor');
  if (shouldBypass) {
    return next(req);
  }

  const url: string = `${!req.url.includes(environment.authServer) ? environment.apiUrl : ''}${req.url}`;
  const apiReq = req.clone({ url });

  return next(apiReq);
};
